import * as api from '~/services/api';

function downloadFile(base64, name) {
  const link = document.createElement('a');
  link.href = base64;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default async function requestFileDownload(
  documentId,
  isLoading,
  isPrivate
) {
  try {
    if (isLoading) isLoading(true);
    const {
      data: { document: base64, name },
    } = await api.downloadFile(documentId, isPrivate);
    downloadFile(base64, name);
  } finally {
    if (isLoading) isLoading(false);
  }
}
